import { css } from "lit-element";

export const StofwareToggleElementStyle = css`
	.toggle-element {
		background-color: var(--app-white);
		top: auto;
		right: 0;
		overflow: hidden;
		height: 0;
		padding: 0;
	}
	.toggle-element.active {
		height: auto;
	}
`;
